import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.div`
  width: ${(props) => (props.squareVersion ? props.size : props.size - 1.5)}px;
  height: ${(props) => (props.squareVersion ? props.size : props.size - 1.5)}px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${(props) => (props.round ? '50%' : '0')};
  background-color: ${(props) => props.fillColor};
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${(props) => props.hoverColor || props.fillColor};
  }

  svg {
    width: ${(props) => props.size / 2}px;
    height: ${(props) => props.size / 2}px;
  }
`;

const SocialIcon = ({
  src,
  size = 50,
  round = false,
  alt = '',
  big,
  fillColor = 'transparent',
  hoverColor,
  onClick,
  style = {},
  squareVersion = false,
}) => (
  <IconWrapper
    size={size}
    round={round}
    fillColor={fillColor}
    hoverColor={hoverColor}
    onClick={onClick}
    style={style}
    squareVersion={squareVersion}
  >
    {src && (
      <img
        src={src}
        aria-label={alt}
        alt={alt || 'social-icon'}
        width={big ? size / 2 + 10 : size / 2}
        height={big ? size / 2 + 10 : size / 2}
      />
    )}
  </IconWrapper>
);

SocialIcon.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
  round: PropTypes.bool,
  fillColor: PropTypes.string,
  hoverColor: PropTypes.string,
  big: PropTypes.bool,
  alt: PropTypes.string.isRequired,
  style: PropTypes.object,
  squareVersion: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SocialIcon;
